<div class="insured-step-wrapper">
  <div class="row">
    <div class="col">
      <h5>Asegurados ({{ filteredList.length }})</h5>
      <hr />
      <div class="form-group">
        <input
          class="form-control"
          placeholder="Buscar asegurados"
          [(ngModel)]="searchTerm"
          (input)="filterInsuredList()"
        />
      </div>

      <div class="insured-list-scroll">
        @for (insured of filteredList; track $index) {
          <div
            (click)="selectInsured(insured, $index)"
            [ngClass]="{
              'insured-selected': $index === indexSelected,
              'insured-hover': true,
            }"
            class="card shadow-sm border-0 my-3 p-3"
          >
            <div class="d-flex align-items-center gap-1 my-1">
              <span class="material-symbols-outlined fw-light">id_card</span>
              <span><strong>{{ insured.name }}</strong></span>
            </div>
            <div class="d-flex align-items-center gap-1 my-1">
              <span>Parentesco: </span>
              <span>{{ insured?.relationship || "Titular" }}</span>
            </div>
          </div>
        } @empty {
          <div class="d-flex justify-content-center p-2">Sin asegurados</div>
        }
      </div>
    </div>
  </div>

  @if (showBackButton) {
    <div class="row mt-4">
      <div class="d-flex justify-content-between">
        <button (click)="goBack()" class="btn btn-lg btn-default border">
          Regresar
        </button>
        <button
          (click)="goNext()"
          class="btn btn-success btn-lg border-0 bg-colonial"
          [disabled]="indexSelected === null || indexSelected === undefined"
        >
          Siguiente
        </button>
      </div>
    </div>
  }
</div>
